// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rk-0";